import React from "react";
import { useRef, useState } from "react";
import { useHistory } from "react-router";
import Header from "./Header";
import "./ForgotPassword.css"
import Footer from "./Footer";
import { FadeLoader } from "react-spinners" ;
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import {authenticateForgotPass} from "../service/api.js"

export default function ForgotPassword() {
  const [email,setEmail]=useState("");
  const [loading, setLoading] = useState(false);
  const [others,setOthers] =useState('none');
  const [openSnackBar,setOpenSnackBar]=useState(false);
  const [severity,setSeverity]=useState("");
  const [msg,setMsg]=useState("");

  async function handleSubmit(e) {
  e.preventDefault();
    console.log("inside handlesubmit")
  //Email validation & verification
  try {
    setLoading(true);
    setOthers('block');
    console.log(email);
    let response=await authenticateForgotPass({
        email: email,
    })
    console.log(response);
    if(response){
      console.log(response)
      setOpenSnackBar(true);
      if(response.status==200){
        setSeverity("success");
      }
      else{
        setLoading(false);
        setOthers('none');
        setSeverity("error");
      }
      setMsg(response.data);
    }
  }
  catch(error){
    setLoading(false);
    setOthers('none');
    setOpenSnackBar(true);
    setSeverity("error");
    setMsg(error.message);
  }
}
  function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
  }



  return (
    <>
    <div className="LoadingScreen" style={{display:others}}>
      <div className="loader">
    <FadeLoader color={"#B8B8B8"} loading={loading} size={150}/>
      </div>
    </div>
    <div>
      {console.log(email)}
    <div className="LoadingScreen" style={{display:others}}>
      <div className="loader">
    <FadeLoader color={"#B8B8B8"} loading={loading} size={150}/>
      </div>
    </div>
    <Header/>
    <div className="centerlogfor">
      <h1>Forgot password</h1>
      <form className="fgt-form">
        <div className="text_field1">
          <input
            type="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <label htmlFor="email" >
            Email
          </label>
        </div>
         
        <button
          type="submit"
          className="sub-button"
          onClick={handleSubmit}
         >
          Reset Password Link
        </button>
      </form>
    </div>
    <Footer/>
      <Snackbar
        anchorOrigin={{ vertical:'bottom', horizontal:'left' }}
        open={openSnackBar}
        autoHideDuration={8000}
        onClose={handleClose}
        >
        <Alert onClose={handleClose} severity={severity}>
            {msg}
        </Alert>
      </Snackbar>
    </div>
  </>
  );
}
